// app/services/payment.service.js
import { api } from './api';

class PaymentService {
    async getServicePayment(serviceId) {
        return api.get(`/api/admin/services/${serviceId}/payment`);
    }

    async getPaymentsConfig() {
        return api.get('/api/admin/payments/config');
    }

    async sendPaymentLink(serviceId, payload = {}) {
        return api.post(`/api/admin/services/${serviceId}/payment/send-link`, payload);
    }

    async recordManualPayment(serviceId, payload) {
        return api.post(`/api/admin/services/${serviceId}/payment/manual`, payload);
    }

    async refundPayment(serviceId, payload) {
        return api.post(`/api/admin/services/${serviceId}/payment/refund`, payload);
    }
}

export const paymentService = new PaymentService();
export default paymentService;
